import { datadogRum } from '@datadog/browser-rum';

export function addError(error: unknown, context?: object | undefined) {
  if (!datadogRum.getInitConfiguration()) {
    // eslint-disable-next-line no-console
    console.error(error, ...(context ? [context] : []));
    return;
  }

  datadogRum.addError(error, context);
}
